// Versão de release do SIGMA (semver limpo, ex. "4.2.0"). Fonte: o
// package.json deste próprio pacote, mantido em sincronia com a raiz do
// monorepo e com sir-prod só por scripts/release.sh (nunca editado à mão) --
// ver "Versionamento e Releases" no README. Não confundir com o campo
// "Versão:" técnico de config/logs (sir-prod/package.json + timestamp do
// último commit no CIR, calculado no servidor).
import pkg from "../package.json";

export default pkg.version;
